'use es6';

import { EERIE } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import UIDropdownCaret from 'UIComponents/dropdown/UIDropdownCaret';
export default styled(UIDropdownCaret).withConfig({
  displayName: "SimpleStyledCaret",
  componentId: "sc-15l804h-0"
})(["color:", ";"], EERIE);